import { Injectable } from '@angular/core';

@Injectable()
export class Utility {
  public static HYPERLINK_REGEXP: RegExp = /^((?:http|ftp)s?:\/\/)(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z]{2,6}\.?|[A-Z0-9-]{2,}\.?)|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/?|[\/?]\S+)$/i;
  public static NUMBER_REGEXP: RegExp = /^\d+$/;
  public static EMAIL_REGEXP: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

  constructor() {}

  public static getTodayDate() {
    const today = new Date();
    const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // const orderDate = Number(new Date(date));
    return date;
  }

  public static findIndexToUpdate(newItem) {
    return newItem.id === this;
  }

  public static convert(value) {
    // Unixtimestamp
    const unixtimestamp = value;

    // Months array
    const months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // Convert timestamp to milliseconds
    const date = new Date(unixtimestamp);

    // Year
    const year = date.getFullYear();

    // Month
    const month = months_arr[date.getMonth()];

    // Day
    const day = date.getDate();

    // Hours
    const hours = date.getHours();

    // Minutes
    const minutes = '0' + date.getMinutes();

    // Seconds
    const seconds = '0' + date.getSeconds();

    // Display date time in MM-dd-yyyy h:m:s format
    const convdataTime = year + ' ' + month + ' ' + day;

    return convdataTime;
  }

  public static formatText(txt): string {
    return txt
      .split('-')
      .join(' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());
  }

  public static camelize(string) {
    return string
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
        return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
      })
      .replace(/\s+/g, '');
  }

  public static camelToDash(string) {
    return string.replace(/([A-Z])/g, function($1) {
      return '-' + $1.toLowerCase();
    });
  }

  public static dashToCamel(string: string): string {
    return string
      .split('-')
      .join(' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());
  }

  public static isEmpty(string: string): boolean {
    return !string || 0 === string.trim().length;
  }

  public static moveArrayElement(arr: Array<any>, element: any, toIndex: number): void {
    const fromIndex = arr.indexOf(element);
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  public static pushIfUnique(array: Array<any>, item: any, property: string): void {
    if (
      array.findIndex((obj) => {
        return obj[property] === item[property];
      }) < 0
    ) {
      array.push(item);
    }
  }

  public static pushAndReplace(array: Array<any>, item: any, property: string): void {
    const itemIndex = array.findIndex((obj) => {
      return obj[property] === item[property];
    });
    if (itemIndex < 0) {
      array.push(item);
    } else {
      array[itemIndex] = item;
    }
  }

  public static isMobileOrTablet(): boolean {
    return !!(
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    );
  }

  public static isIE(): boolean {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');

    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10) > 0;
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) > 0;
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10) > 0;
    }

    // other browser
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/utility.ts